import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Compass } from "@phosphor-icons/react";
import { api, appUserAuth } from "../lib/api";
import { progressEvent, WELCOME_FLAG } from "../lib/progress";

export default function WelcomeFit({ onClose }) {
  const navigate = useNavigate();
  const first = (appUserAuth.fullName() || "").split(" ")[0];
  React.useEffect(() => {
    progressEvent("welcome_view");
    const ref = localStorage.getItem("ex_ref");
    if (ref) api.post("/app/ref/attribute", { code: ref }).catch(() => {}).finally(() => localStorage.removeItem("ex_ref"));
  }, []);

  const close = (go) => {
    localStorage.removeItem(WELCOME_FLAG);
    if (go) { progressEvent("welcome_start"); navigate("/quiz"); }
    onClose();
  };

  return (
    <div data-testid="welcome-fit-screen" className="fixed inset-0 z-[110] bg-exodus-bg text-exodus-text overflow-y-auto">
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-xl w-full text-center rise">
          <Compass size={44} weight="thin" className="text-exodus-gold mx-auto" />
          <p className="eyebrow mt-8">Your access is ready{first ? `, ${first}` : ""}</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1]">
            Start with <span className="gold-text italic">one simple step.</span>
          </h1>
          <button data-testid="welcome-start-fit" onClick={() => close(true)} className="btn-gold mt-10 w-full sm:w-auto justify-center">
            Start Find My Fit (4 minutes) <ArrowRight size={18} weight="bold" />
          </button>
          <p data-testid="welcome-supporting-line" className="text-sm text-exodus-muted mt-5 max-w-md mx-auto">
            At the end you'll get your recommended next step — no pressure, no sales calls.
          </p>
          <button data-testid="welcome-skip" onClick={() => close(false)} className="text-xs text-exodus-muted hover:text-exodus-text underline mt-10">
            I'll explore first
          </button>
        </div>
      </div>
    </div>
  );
}
